/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceJobV1TaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_JOB_V1_TASK_STATE_ENTITY_NAME = 'exc.ice.job.v1.Task';
export const excIceJobV1TaskStateEntity = new schema.Entity<ExcIceJobV1TaskState>(EXC_ICE_JOB_V1_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

